<app-peptide-therapy
  htmlTitle="<strong>Important: Boost</strong> Recovery & Vitality with Peptide Therapy"
  question="Would you like to add Peptide Therapy for the most complete Results?"
  [options]="options"
>
  <p class="mb-4">
    Many men on testosterone also deal with slow recovery, inflammation, trouble losing fat, low energy, or plateaus in
    muscle and strength. Peptide therapy supports tissue repair, metabolic function, and cellular healing — helping your
    TRT deliver even better, more complete results.
  </p>
  <ul class="mb-4">
    <li>
      <strong>BPC-157</strong> reduces inflammation and accelerates tissue repair, helping your body recover faster and
      feel better day to day.
    </li>
    <li>
      <strong>CJC-1295/Ipamorelin</strong> supports natural growth hormone release to improve recovery, sleep quality,
      energy, and metabolic health.
    </li>
    <li>
      <strong>GHK-Cu</strong> enhances circulation, collagen production, and cellular repair — supporting healthier
      skin, joints, and overall vitality.
    </li>
  </ul>
  <p class="mb-4">
    Most men notice improved energy, faster recovery, better body composition, and stronger overall wellness when
    combining peptides with TRT.
  </p>
</app-peptide-therapy>
